import React from 'react';
import { connect } from 'react-redux';

import { EQUIVOCAL, NEGATIVE, PENDING, POSITIVE } from '../api/mappers/labResultMapper';

import EquivocalImportantInfo from '../components/equivocalImportantInfo';
import NegativeImportantInfo from '../components/negativeImportantInfo';
import NoResultImportantInfo from '../components/noResultImportantInfo';
import PositiveImportantInfo from '../components/positiveImportantInfo';

class ImportantInfo extends React.Component {

    componentDidMount(){
        console.log(this.props.selectedLabResult);
    }
    componentDidUpdate(){
        console.log(this.props.selectedLabResult);
    }

    renderMainContent() {
        let check = '';
        if (this.props.labResults == null || this.props.labResults.length < 0) {
            return null;
        }
        if(this.props.selectedLabResult !== null){
            check = this.props.selectedLabResult.result;
        }
        if (check === POSITIVE) {
            return <PositiveImportantInfo />
        } else if (check === NEGATIVE) {
            return <NegativeImportantInfo />
        } else if (check === PENDING) {
            return <NoResultImportantInfo />
        } else if (check === EQUIVOCAL) {
            return <EquivocalImportantInfo />
        } else {
            return null;
        }
    }

    render() {
        if (this.props.isModal === false) {
            let mainClasses = "alert alert-success hideMobile";
            let resultsClasses = "alert alert-success hideDT";
            let curClasses = mainClasses;
            if ( this.props.isResults === true) {
                curClasses = resultsClasses;
            }
            return (
                <div class={curClasses} role="alert">
                    <h4 class="alert-heading">{this.props.strings.IMPORTANT_INFO_HEADER}</h4>
                    {this.renderMainContent()}
                </div>
            );
        } else {
            return this.renderMainContent();
        }
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        labResults: state.api.labResults,
        strings: state.language.strings,
        selectedLabResult: state.api.selectedLabResult,
    }
}

const ConnectedImportantInfo = connect(
    mapStateToProps
)(ImportantInfo);
export default ConnectedImportantInfo;
